import React, { useState} from 'react';

const FaqItem = ({ title, content }) => {
    const [isActive, setIsActive] = useState(false);

    return (
        <div className={isActive ? "accordion-item active" : "accordion-item"}>
            <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
                {title}
                <span className="accordion-title-icon">{isActive ? '-' : '+'}</span>
            </div>
            <div className="accordion-content-container" >
                <div className="accordion-content">
                    <p className="roadmap-item-detail-sub" dangerouslySetInnerHTML={{ __html: content}}></p>
                </div>
            </div>
        </div>
    );
};

export default FaqItem;